import * as React from "react"
import {Link as RouterLink} from "react-router-dom";
import {Link} from "@mui/material";

export default function AppLink({ path, external, children, ...props }) {
	// Prop "external" remove to rest props. Dont delete
	return <Link component={RouterLink} underline="none" {...props}>
		{children}
	</Link>
}